export default __webpack_public_path__ + "media/images/features/local_delivery/local-delivery-e12dc03a893694dc8020351603d735c1.jpg";